<template>
  <div class="uni-calendar" @mouseleave="leaveCale">
    <div
      v-if="!insert && show"
      class="uni-calendar__mask"
      :class="{ 'uni-calendar--mask-show': aniMaskShow }"
      @click="maskClick"
    ></div>

    <div
      v-if="insert || show"
      class="uni-calendar__content"
      :class="{
        'uni-calendar--fixed': !insert,
        'uni-calendar--ani-show': aniMaskShow,
        'uni-calendar__content-mobile': aniMaskShow
      }"
    >
      <div class="uni-calendar__header" :class="{ 'uni-calendar__header-mobile': !insert }">
        <div class="uni-calendar__header-btn-box" @click.stop="changeMonth('pre')">
          <div class="uni-calendar__header-btn uni-calendar--left"></div>
        </div>

        <picker mode="date" :value="date" fields="month" @change="bindDateChange">
          <span class="uni-calendar__header-text">{{
            (nowDate.year || '') + yearText + (nowDate.month || '') + monthText
          }}</span>
        </picker>

        <div class="uni-calendar__header-btn-box" @click.stop="changeMonth('next')">
          <div class="uni-calendar__header-btn uni-calendar--right"></div>
        </div>

        <div v-if="!insert" class="dialog-close" @click="maskClick">
          <div class="dialog-close-plus" data-id="close"></div>
          <div class="dialog-close-plus dialog-close-rotate" data-id="close"></div>
        </div>
      </div>
      <div class="uni-calendar__box">
        <div v-if="showMonth" class="uni-calendar__box-bg">
          <span class="uni-calendar__box-bg-text">{{ nowDate.month }}</span>
        </div>

        <div class="uni-calendar__weeks" style="padding-bottom: 0.149333rem">
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ SUNText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ MONText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ TUEText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ WEDText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ THUText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ FRIText }}</span>
          </div>
          <div class="uni-calendar__weeks-day">
            <span class="uni-calendar__weeks-day-text">{{ SATText }}</span>
          </div>
        </div>

        <div class="uni-calendar__weeks" v-for="(item, weekIndex) in weeks" :key="weekIndex">
          <div
            class="uni-calendar__weeks-item"
            v-for="(weeks, weeksIndex) in item"
            :key="weeksIndex"
          >
            <calendar-item
              class="uni-calendar-item--hook"
              :weeks="weeks"
              :calendar="calendar"
              :selected="selected"
              :checkHover="range"
              @change="choiceDate"
              @handleMouse="handleMouse"
            >
            </calendar-item>
          </div>
        </div>
      </div>

      <div
        v-if="!insert && !range && hasTime"
        class="uni-date-changed uni-calendar--fixed-top"
        style="padding: 0 1.706667rem"
      >
        <div class="uni-date-changed--time-date">
          {{ tempSingleDate ? tempSingleDate : selectDateText }}
        </div>
        <time-picker
          type="time"
          :start="timepickerStartTime"
          :end="timepickerEndTime"
          v-model="time"
          :disabled="!tempSingleDate"
          :border="false"
          :hide-second="hideSecond"
          class="time-picker-style"
        >
        </time-picker>
      </div>

      <div v-if="!insert && range && hasTime" class="uni-date-changed uni-calendar--fixed-top">
        <div class="uni-date-changed--time-start">
          <div class="uni-date-changed--time-date">
            {{ tempRange.before ? tempRange.before : startDateText }}
          </div>
          <time-picker
            type="time"
            :start="timepickerStartTime"
            v-model="timeRange.startTime"
            :border="false"
            :hide-second="hideSecond"
            :disabled="!tempRange.before"
            class="time-picker-style"
          >
          </time-picker>
        </div>
        <div style="line-height: 1.066667rem">
          <uni-icons type="arrowthinright" color="#999"></uni-icons>
        </div>
        <div class="uni-date-changed--time-end">
          <div class="uni-date-changed--time-date">
            {{ tempRange.after ? tempRange.after : endDateText }}
          </div>
          <time-picker
            type="time"
            :end="timepickerEndTime"
            v-model="timeRange.endTime"
            :border="false"
            :hide-second="hideSecond"
            :disabled="!tempRange.after"
            class="time-picker-style"
          >
          </time-picker>
        </div>
      </div>

      <div v-if="!insert" class="uni-date-changed uni-date-btn--ok">
        <div class="uni-datetime-picker--btn" @click="confirm">{{ confirmText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Calendar, getDate, getTime } from './util.js'
import calendarItem from './calendar-item.vue'
import timePicker from './time-picker.vue'

// import { initVueI18n } from '@dcloudio/uni-i18n'
// import i18nMessages from './i18n/index.js'
// const { t } = initVueI18n(i18nMessages)

/**
 * Calendar 日历
 * @description 日历组件可以查看日期，选择任意范围内的日期，打点操作。常用场景如：酒店日期预订、火车机票选择购买日期、上下班打卡等
 * @tutorial https://ext.dcloud.net.cn/plugin?id=56
 * @property {String} date 自定义当前时间，默认为今天
 * @property {String} startDate 日期选择范围-开始日期
 * @property {String} endDate 日期选择范围-结束日期
 * @property {Boolean} range 范围选择
 * @property {Boolean} insert = [true|false] 插入模式,默认为false
 * 	@value true 弹窗模式
 * 	@value false 插入模式
 * @property {Boolean} clearDate = [true|false] 弹窗模式是否清空上次选择内容
 * @property {Array} selected 打点，期待格式[{date: '2019-06-27', info: '签到', data: { custom: '自定义信息', name: '自定义消息头',xxx:xxx... }}]
 * @property {Boolean} showMonth 是否选择月份为背景
 * @property {[String} defaultValue 选择器打开时默认显示的时间
 * @event {Function} change 日期改变，`insert :ture` 时生效
 * @event {Function} confirm 确认选择`insert :false` 时生效
 * @event {Function} monthSwitch 切换月份时触发
 * @example <uni-calendar :insert="true" :start-date="'2019-3-2'":end-date="'2019-5-20'"@change="change" />
 */
export default {
  components: {
    calendarItem,
    timePicker
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    defTime: {
      type: [String, Object],
      default: ''
    },
    selectableTimes: {
      type: [Object],
      default() {
        return {}
      }
    },
    selected: {
      type: Array,
      default() {
        return []
      }
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    startPlaceholder: {
      type: String,
      default: ''
    },
    endPlaceholder: {
      type: String,
      default: ''
    },
    range: {
      type: Boolean,
      default: false
    },
    hasTime: {
      type: Boolean,
      default: false
    },
    insert: {
      type: Boolean,
      default: true
    },
    showMonth: {
      type: Boolean,
      default: true
    },
    clearDate: {
      type: Boolean,
      default: true
    },
    checkHover: {
      type: Boolean,
      default: true
    },
    hideSecond: {
      type: [Boolean],
      default: false
    },
    pleStatus: {
      type: Object,
      default() {
        return {
          before: '',
          after: '',
          data: [],
          fulldate: ''
        }
      }
    },
    defaultValue: {
      type: [String, Object, Array],
      default: ''
    }
  },
  data() {
    return {
      show: false,
      weeks: [],
      calendar: {},
      nowDate: {},
      aniMaskShow: false,
      firstEnter: true,
      time: '',
      timeRange: {
        startTime: '',
        endTime: ''
      },
      tempSingleDate: '',
      tempRange: {
        before: '',
        after: ''
      }
    }
  },
  watch: {
    date: {
      immediate: true,
      handler(newVal) {
        if (!this.range) {
          this.tempSingleDate = newVal
          setTimeout(() => {
            this.init(newVal)
          }, 100)
        }
      }
    },
    defTime: {
      immediate: true,
      handler(newVal) {
        if (!this.range) {
          this.time = newVal
        } else {
          this.timeRange.startTime = newVal.start
          this.timeRange.endTime = newVal.end
        }
      }
    },
    startDate(val) {
      // 字节小程序 watch 早于 created
      if (!this.cale) {
        return
      }
      this.cale.setStartDate(val)
      this.cale.setDate(this.nowDate.fullDate)
      this.weeks = this.cale.weeks
    },
    endDate(val) {
      // 字节小程序 watch 早于 created
      if (!this.cale) {
        return
      }
      this.cale.setEndDate(val)
      this.cale.setDate(this.nowDate.fullDate)
      this.weeks = this.cale.weeks
    },
    selected(newVal) {
      // 字节小程序 watch 早于 created
      if (!this.cale) {
        return
      }
      this.cale.setSelectInfo(this.nowDate.fullDate, newVal)
      this.weeks = this.cale.weeks
    },
    pleStatus: {
      immediate: true,
      handler(newVal) {
        const { before, after, fulldate, which } = newVal
        this.tempRange.before = before
        this.tempRange.after = after
        setTimeout(() => {
          if (fulldate) {
            this.cale.setHoverMultiple(fulldate)
            if (before && after) {
              this.cale.lastHover = true
              if (this.rangeWithinMonth(after, before)) return
              this.setDate(before)
            } else {
              this.cale.setMultiple(fulldate)
              this.setDate(this.nowDate.fullDate)
              this.calendar.fullDate = ''
              this.cale.lastHover = false
            }
          } else {
            // 字节小程序 watch 早于 created
            if (!this.cale) {
              return
            }

            this.cale.setDefaultMultiple(before, after)
            if (which === 'left' && before) {
              this.setDate(before)
              this.weeks = this.cale.weeks
            } else if (after) {
              this.setDate(after)
              this.weeks = this.cale.weeks
            }
            this.cale.lastHover = true
          }
        }, 16)
      }
    }
  },
  computed: {
    timepickerStartTime() {
      const activeDate = this.range ? this.tempRange.before : this.calendar.fullDate
      return activeDate === this.startDate ? this.selectableTimes.start : ''
    },
    timepickerEndTime() {
      const activeDate = this.range ? this.tempRange.after : this.calendar.fullDate
      return activeDate === this.endDate ? this.selectableTimes.end : ''
    },
    /**
     * for i18n
     */
    selectDateText() {
      return t('uni-datetime-picker.selectDate')
    },
    startDateText() {
      return this.startPlaceholder || t('uni-datetime-picker.startDate')
    },
    endDateText() {
      return this.endPlaceholder || t('uni-datetime-picker.endDate')
    },
    okText() {
      return t('uni-datetime-picker.ok')
    },
    yearText() {
      return t('uni-datetime-picker.year')
    },
    monthText() {
      return t('uni-datetime-picker.month')
    },
    MONText() {
      return t('uni-calender.MON')
    },
    TUEText() {
      return t('uni-calender.TUE')
    },
    WEDText() {
      return t('uni-calender.WED')
    },
    THUText() {
      return t('uni-calender.THU')
    },
    FRIText() {
      return t('uni-calender.FRI')
    },
    SATText() {
      return t('uni-calender.SAT')
    },
    SUNText() {
      return t('uni-calender.SUN')
    },
    confirmText() {
      return t('uni-calender.confirm')
    }
  },
  created() {
    // 获取日历方法实例
    this.cale = new Calendar({
      selected: this.selected,
      startDate: this.startDate,
      endDate: this.endDate,
      range: this.range
    })
    // 选中某一天
    this.init(this.date)
  },
  methods: {
    leaveCale() {
      this.firstEnter = true
    },
    handleMouse(weeks) {
      if (weeks.disable) return
      if (this.cale.lastHover) return
      let { before, after } = this.cale.multipleStatus
      if (!before) return
      this.calendar = weeks
      // 设置范围选
      this.cale.setHoverMultiple(this.calendar.fullDate)
      this.weeks = this.cale.weeks
      // hover时，进入一个日历，更新另一个
      if (this.firstEnter) {
        this.$emit('firstEnterCale', this.cale.multipleStatus)
        this.firstEnter = false
      }
    },
    rangeWithinMonth(A, B) {
      const [yearA, monthA] = A.split('-')
      const [yearB, monthB] = B.split('-')
      return yearA === yearB && monthA === monthB
    },
    // 蒙版点击事件
    maskClick() {
      this.close()
      this.$emit('maskClose')
    },

    clearCalender() {
      if (this.range) {
        this.timeRange.startTime = ''
        this.timeRange.endTime = ''
        this.tempRange.before = ''
        this.tempRange.after = ''
        this.cale.multipleStatus.before = ''
        this.cale.multipleStatus.after = ''
        this.cale.multipleStatus.data = []
        this.cale.lastHover = false
      } else {
        this.time = ''
        this.tempSingleDate = ''
      }
      this.calendar.fullDate = ''
      this.setDate(new Date())
    },

    bindDateChange(e) {
      const value = e.detail.value + '-1'
      this.setDate(value)
    },
    /**
     * 初始化日期显示
     * @param {Object} date
     */
    init(date) {
      // 字节小程序 watch 早于 created
      if (!this.cale) {
        return
      }
      this.cale.setDate(date || new Date())
      this.weeks = this.cale.weeks
      this.nowDate = this.cale.getInfo(date)
      this.calendar = { ...this.nowDate }
      if (!date) {
        // 优化date为空默认不选中今天
        this.calendar.fullDate = ''
        if (this.defaultValue && !this.range) {
          // 暂时只支持移动端非范围选择
          const defaultDate = new Date(this.defaultValue)
          const fullDate = getDate(defaultDate)
          const year = defaultDate.getFullYear()
          const month = defaultDate.getMonth() + 1
          const date = defaultDate.getDate()
          const day = defaultDate.getDay()
          ;(this.calendar = {
            fullDate,
            year,
            month,
            date,
            day
          }),
            (this.tempSingleDate = fullDate)
          this.time = getTime(defaultDate, this.hideSecond)
        }
      }
    },
    /**
     * 打开日历弹窗
     */
    open() {
      // 弹窗模式并且清理数据
      if (this.clearDate && !this.insert) {
        this.cale.cleanMultipleStatus()
        this.init(this.date)
      }
      this.show = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.aniMaskShow = true
        }, 50)
      })
    },
    /**
     * 关闭日历弹窗
     */
    close() {
      this.aniMaskShow = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.show = false
          this.$emit('close')
        }, 300)
      })
    },
    /**
     * 确认按钮
     */
    confirm() {
      this.setEmit('confirm')
      this.close()
    },
    /**
     * 变化触发
     */
    change() {
      if (!this.insert) return
      this.setEmit('change')
    },
    /**
     * 选择月份触发
     */
    monthSwitch() {
      let { year, month } = this.nowDate
      this.$emit('monthSwitch', {
        year,
        month: Number(month)
      })
    },
    /**
     * 派发事件
     * @param {Object} name
     */
    setEmit(name) {
      if (!this.range) {
        if (!this.calendar.fullDate) {
          this.calendar = this.cale.getInfo(new Date())
          this.tempSingleDate = this.calendar.fullDate
        }
        if (this.hasTime && !this.time) {
          this.time = getTime(new Date(), this.hideSecond)
        }
      }
      let { year, month, date, fullDate, extraInfo } = this.calendar
      this.$emit(name, {
        range: this.cale.multipleStatus,
        year,
        month,
        date,
        time: this.time,
        timeRange: this.timeRange,
        fulldate: fullDate,
        extraInfo: extraInfo || {}
      })
    },
    /**
     * 选择天触发
     * @param {Object} weeks
     */
    choiceDate(weeks) {
      if (weeks.disable) return
      this.calendar = weeks
      this.calendar.userChecked = true
      // 设置多选
      this.cale.setMultiple(this.calendar.fullDate, true)
      this.weeks = this.cale.weeks
      this.tempSingleDate = this.calendar.fullDate
      const beforeDate = new Date(this.cale.multipleStatus.before).getTime()
      const afterDate = new Date(this.cale.multipleStatus.after).getTime()
      if (beforeDate > afterDate && afterDate) {
        this.tempRange.before = this.cale.multipleStatus.after
        this.tempRange.after = this.cale.multipleStatus.before
      } else {
        this.tempRange.before = this.cale.multipleStatus.before
        this.tempRange.after = this.cale.multipleStatus.after
      }
      this.change()
    },
    changeMonth(type) {
      let newDate
      if (type === 'pre') {
        newDate = this.cale.getPreMonthObj(this.nowDate.fullDate).fullDate
      } else if (type === 'next') {
        newDate = this.cale.getNextMonthObj(this.nowDate.fullDate).fullDate
      }

      this.setDate(newDate)
      this.monthSwitch()
    },
    /**
     * 设置日期
     * @param {Object} date
     */
    setDate(date) {
      this.cale.setDate(date)
      this.weeks = this.cale.weeks
      this.nowDate = this.cale.getInfo(date)
    }
  }
}
</script>

<style lang="scss">
$uni-primary: #007aff !default;

.uni-calendar {
  display: flex;
  flex-direction: column;
}

.uni-calendar__mask {
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  transition-property: opacity;
  transition-duration: 0.3s;
  opacity: 0;
  z-index: 99;
}

.uni-calendar--mask-show {
  opacity: 1;
}

.uni-calendar--fixed {
  position: fixed;
  bottom: calc(var(--window-bottom));
  left: 0;
  right: 0;
  transition-property: transform;
  transition-duration: 0.3s;
  transform: translateY(9.813333rem);
  z-index: 99;
}

.uni-calendar--ani-show {
  transform: translateY(0);
}

.uni-calendar__content {
  background-color: #fff;
}

.uni-calendar__content-mobile {
  border-top-left-radius: 0.213333rem;
  border-top-right-radius: 0.213333rem;
  box-shadow: 0rem 0rem 0.106667rem 0.064rem rgba(0, 0, 0, 0.1);
}

.uni-calendar__header {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 1.066667rem;
}

.uni-calendar__header-mobile {
  padding: 0.213333rem;
  padding-bottom: 0;
}

.uni-calendar--fixed-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top-color: rgba(0, 0, 0, 0.4);
  border-top-style: solid;
  border-top-width: 0.021333rem;
}

.uni-calendar--fixed-width {
  width: 1.066667rem;
}

.uni-calendar__backtoday {
  position: absolute;
  right: 0;
  top: 0.533333rem;
  padding: 0 0.106667rem;
  padding-left: 0.213333rem;
  height: 0.533333rem;
  line-height: 0.533333rem;
  font-size: 0.256rem;
  border-top-left-radius: 0.533333rem;
  border-bottom-left-radius: 0.533333rem;
  color: #fff;
  background-color: #f1f1f1;
}

.uni-calendar__header-text {
  text-align: center;
  width: 2.133333rem;
  font-size: 0.32rem;
  color: #666;
}

.uni-calendar__button-text {
  text-align: center;
  width: 2.133333rem;
  font-size: 0.298667rem;
  color: $uni-primary;
  letter-spacing: 0.064rem;
}

.uni-calendar__header-btn-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 1.066667rem;
  height: 1.066667rem;
}

.uni-calendar__header-btn {
  width: 0.192rem;
  height: 0.192rem;
  border-left-color: #808080;
  border-left-style: solid;
  border-left-width: 0.021333rem;
  border-top-color: #555555;
  border-top-style: solid;
  border-top-width: 0.021333rem;
}

.uni-calendar--left {
  transform: rotate(-45deg);
}

.uni-calendar--right {
  transform: rotate(135deg);
}

.uni-calendar__weeks {
  position: relative;
  display: flex;
  flex-direction: row;
}

.uni-calendar__weeks-item {
  flex: 1;
}

.uni-calendar__weeks-day {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 0.853333rem;
  border-bottom-color: #f5f5f5;
  border-bottom-style: solid;
  border-bottom-width: 0.021333rem;
}

.uni-calendar__weeks-day-text {
  font-size: 0.256rem;
  color: #b2b2b2;
}

.uni-calendar__box {
  position: relative;
  // padding: 0 .213333rem;
  padding-bottom: 0.149333rem;
}

.uni-calendar__box-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.uni-calendar__box-bg-text {
  font-size: 4.266667rem;
  font-weight: bold;
  color: #999;
  opacity: 0.1;
  text-align: center;
  line-height: 1;
}

.uni-date-changed {
  padding: 0 0.213333rem;
  // line-height: 1.066667rem;
  text-align: center;
  color: #333;
  border-top-color: #dcdcdc;
  border-top-style: solid;
  border-top-width: 0.021333rem;
  flex: 1;
}

.uni-date-btn--ok {
  padding: 0.426667rem 0.32rem;
}

.uni-date-changed--time-start {
  display: flex;
  align-items: center;
}

.uni-date-changed--time-end {
  display: flex;
  align-items: center;
}

.uni-date-changed--time-date {
  color: #999;
  line-height: 1.066667rem;
  margin-right: 0.106667rem;
  // opacity: 0.6;
}

.time-picker-style {
  // width: 1.322667rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mr-10 {
  margin-right: 0.213333rem;
}

.dialog-close {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0.533333rem;
  margin-top: 0.213333rem;
}

.dialog-close-plus {
  width: 0.341333rem;
  height: 0.042667rem;
  background-color: #737987;
  border-radius: 0.042667rem;
  transform: rotate(45deg);
}

.dialog-close-rotate {
  position: absolute;
  transform: rotate(-45deg);
}

.uni-datetime-picker--btn {
  border-radius: 2.133333rem;
  height: 0.853333rem;
  line-height: 0.853333rem;
  background-color: $uni-primary;
  color: #fff;
  font-size: 0.341333rem;
  letter-spacing: 0.042667rem;
}

.uni-datetime-picker--btn:active {
  opacity: 0.7;
}
</style>
